<div class="flex center wrap gap bg-white padding-small radius">
  <b class="primary-dark">User guides:</b>

  @if (canDownloadCompanyGuide) {
    <span class="primary-dark hover flex center" (click)="openGuideLanguageModal('company')">
      <i class="fa-solid fa-file-pdf margin-right-smallest"></i>
      Company guide (.pdf)
    </span>
  }

  <span class="primary-dark hover flex center" (click)="openGuideLanguageModal('photographer')">
    <i class="fa-solid fa-file-pdf margin-right-smallest"></i>
    Photographer guide (.pdf)
  </span>
</div>
